mutation RemoveFont($fontId: ID!) {
    removeFont(fontId: $fontId)
}
